export enum ItemDialogConfigEnum {
  APPROVE = 'Approve',
  REJECT = 'Reject',
}
